import {insecureHash} from 'utilities/hash';
import * as AppConstants from 'app/AppConstants';

const keyedFilter = (viewId, filter) => ({
  ...filter,
  id: insecureHash(`${viewId}${filter.dataSourceId}${filter.column}`),
});

const initialState = () => ({
  views: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.VIEW__LOAD_FINISHED: {
      const {viewId, view} = action.payload;
      const filters = view.filters || [];

      return {
        ...state,
        views: {
          ...state.views,
          [viewId]: {
            ...view,
            filters: filters.map(f => keyedFilter(viewId, f)),
          },
        },
      };
    }
    default:
      return state;
  }
};
